import { buildApiOptions, getRequestKey } from "./api-constants-asia";
import getApiHeader from "./getApiHeader";
import _ from "lodash";
import axios from "axios";
const apiPromises = {};
const service = axios.create();
export const r = (path, contentType) => {
  return async (params, data, opts) => {
    const key = getRequestKey(path, contentType, params, data, opts);
    if (apiPromises[key]) {
      const res = await apiPromises[key];
      return handleApiResponse(res);
    } else {
      let options = buildApiOptions(path, contentType, params, data, opts);
      const headers = await getApiHeader();
      options.headers = _.merge(headers, options.headers);
      apiPromises[key] = service.request(options);
      const res = await apiPromises[key];
      delete apiPromises[key];
      return handleApiResponse(res);
    }
  };
};
const handleApiResponse = res => {
  if (res.status === 200 && res.data.code === 200) {
    return [res.data.data, null];
  } else {
    return [null, res.data];
  }
};

export const s = (path, contentType) => {
  return async (params, data, opts) => {
    const key = getRequestKey(path, contentType, params, data, opts);
    if (apiPromises[key]) {
      const res = await apiPromises[key];
      return submitHandleApiResponse(res);
    } else {
      let options = buildApiOptions(path, contentType, params, data, opts);
      const headers = await getApiHeader();
      options.headers = _.merge(headers, options.headers);
      apiPromises[key] = service.request(options);
      const res = await apiPromises[key];
      delete apiPromises[key];
      return submitHandleApiResponse(res);
    }
  };
};
const submitHandleApiResponse = res => {
  return [null, res.data];
};
